// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qm-6";
export var imgContainer = "_qm-3";
export var menuIcon = "_qm-5";
export var pillWrapper = "_qm-2";
export var pillsContainer = "_qm-1";
export var subscriptionCard = "_qm-0";
export var subscriptionLogo = "_qm-4";